import { Link } from "react-router";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Receipt, FileText, ArrowRight } from "lucide-react";
import type { JobDetailDto } from "@/lib/jobs";

export interface JobInvoiceTabProps {
  job: JobDetailDto;
}

export function JobInvoiceTab({ job }: JobInvoiceTabProps) {
  if (!job.generatedInvoiceId) {
    return (
      <Card className="border-dashed shadow-sm">
        <CardContent className="flex flex-col items-center justify-center py-16">
          <div className="rounded-full bg-slate-100 p-4 mb-4">
            <Receipt className="h-8 w-8 text-slate-400" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900 mb-2">Not yet invoiced</h3>
          <p className="text-sm text-slate-500 max-w-sm text-center">
            Generate an invoice from the Actions menu above. The job must be marked as Completed first.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="overflow-hidden shadow-sm">
      <CardContent className="p-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="h-12 w-12 rounded-full border bg-white flex items-center justify-center shadow-sm">
              <FileText className="h-5 w-5 text-slate-600" />
            </div>
            <div>
              <p className="font-medium text-slate-900 text-base">Invoice #{job.generatedInvoiceId}</p>
              <p className="text-sm text-slate-500">Ready for review and sending</p>
            </div>
          </div>
          <Button asChild className="shrink-0">
            <Link to={`/invoices/${job.generatedInvoiceId}`}>
              View Invoice <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
